module.exports = __webpack_public_path__ + "img/office-builing.8cf82a9b.svg";